import angular from 'angular';
import { LoadParams } from '../../../shared/models/loadparams.model';
import { NsjRoutingType } from '../../../core/nsj-core';
import {
    ITrabalhadorApuracaoPontoListItem,
    ITrabalhadorApuracaoPontoConstructor,
    ITrabalhadorApuracaoPontoOffset
} from './models/trabalhadores-apuracao-ponto.service.model';

export class TrabalhadoresApuracaoPontoService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public entity: ITrabalhadorApuracaoPontoListItem;
    public entities: ITrabalhadorApuracaoPontoListItem[] = [];
    public loaded = false;
    public constructors: ITrabalhadorApuracaoPontoConstructor | {} = {};
    public after: ITrabalhadorApuracaoPontoOffset = {};
    public filters: any = {};
    public loadParams = new LoadParams();
    public loading_deferred: angular.IDeferred<unknown>;
    public filter = '';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: NsjRoutingType,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService,
    ) { }

    reload() {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.after = {};
        this.loaded = false;
        this.entities = [];
        this.loadParams = new LoadParams();

        return this.load();
    }

    search(filter?: any) {
        let search = '';

        if (typeof filter !== 'undefined' && filter != null) {
            search = filter.search ? filter.search : '';

            Object.keys(this.filters).forEach((key) => {
                delete this.filters[key];
            });

            for (const filterKey in filter.filters) {
                if (filterKey.indexOf('.') > -1) {
                    const filterSplit = filterKey.split('.');

                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[filterKey];
                } else {
                    this.filters[filterKey] = filter.filters[filterKey];
                }
            }
        } else if (filter == null) {
            return this._load(this.constructors, {}, '');
        }

        return this._load(this.constructors, {}, search);
    }

    _load(constructors: ITrabalhadorApuracaoPontoConstructor | {}, offset: ITrabalhadorApuracaoPontoOffset, filter: string) {
        this.loading_deferred = this.$q.defer();

        return this.$q<ITrabalhadorApuracaoPontoListItem[]>((resolve, reject) => {
            this.$http.get<ITrabalhadorApuracaoPontoListItem[]>(
                this.nsjRouting.generate('ponto_trabalhadores_find_all_by_apuracao_ponto',
                    angular.extend({}, constructors, {
                        'offset': offset,
                        'filter': filter
                    }),
                    true,
                ),
                { timeout: this.loading_deferred.promise }
            ).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data) => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }

                        const lastEntity = this.entities[this.entities.length - 1];
                        this.after = {
                            nome: lastEntity.nome,
                            trabalhador: lastEntity.trabalhador
                        };
                    }

                    this.loaded = true;
                    this.loadParams.to_load--;

                    if (data.length < 50) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('ponto_trabalhadores_apuracao_list_finished', this.entities);
                        return;
                    }

                    this.loadParams.finished = false;

                    if (this.loadParams.to_load === 0) {
                        this.$rootScope.$broadcast('ponto_trabalhadores_apuracao_list_loaded', this.entities);
                    }
                })
                .catch((error) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('ponto_trabalhadores_apuracao_list_error', error);
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

    loadMore() {
        this.loadParams.to_load = 3;
        this.load();
    }
}
